import moment from 'moment-timezone';



function calculateDeviceTimezone() {
  return moment.tz.guess(true);
}



export default calculateDeviceTimezone;
